import { PerspectiveMoreIcon } from './PerspectiveMoreIcon';

/**
 * author: Michael Irigoyen
 * id 6F54CAE0-D2B7-4E00-83AA-0B98A7601CF6
 * name perspective-more
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/perspective-more.svg
 * tags
 * - Math 
 */
export const PerspectiveIncreaseIcon = PerspectiveMoreIcon;
export default PerspectiveIncreaseIcon